import Vue from "vue";
import BackButton from "@/components/BackButton";

Vue.component("BackButton", BackButton);
